import { useElementSize } from "@mantine/hooks";
import type { ResumeDocument } from "../api/client";
import { CvRenderer } from "../cv/renderer";
import styles from "./template-thumb.module.css";

// A4 at 96 dpi.
const PAGE_WIDTH = 793.7;

export function TemplateThumb({
  doc,
  className,
  label,
}: {
  doc: ResumeDocument;
  className?: string;
  label?: string;
}) {
  const { ref, width } = useElementSize();
  const scale = width > 0 ? width / PAGE_WIDTH : 0;

  return (
    <div
      ref={ref}
      className={[styles.frame, className].filter(Boolean).join(" ")}
      aria-hidden={label ? undefined : true}
      role="img"
      aria-label={label}
    >
      <div
        className={styles.inner}
        style={{ transform: `scale(${scale})`, opacity: scale ? 1 : 0 }}
        inert
      >
        <CvRenderer doc={doc} />
      </div>
    </div>
  );
}
